import TelemedicineContext from '../../context/telemedicine';
import { FINISHED_STATUS } from '../../hooks/useFinishCall';
import { LIVEKIT_PROVIDER } from '../../utils/telemedicine';

import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

// LiveKit only - the Twilio flow keeps its own routing untouched.
const FinishedCallGuard = ({ children }) => {
	const { telemedicine } = useContext(TelemedicineContext);

	if (telemedicine?.provider === LIVEKIT_PROVIDER && telemedicine?.status === FINISHED_STATUS) {
		return <Navigate replace to="/telemedicine-finished" />;
	}

	return children;
};

export default FinishedCallGuard;
